import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, consultaCor } from './types';

export const INITIAL_STATE: consultaCor = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaCor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_COR_REQUEST: {
				break;
			}

			case Types.CONSULTA_COR_SUCCESS: {
				draft.status = action.payload.status;
				const select = toSelect(
					action.payload.data.cores,
					'descricao',
					'longId',
				);
				draft.data = select;
				break;
			}

			case Types.CONSULTA_COR_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
